export default [
    {
        meta: {
            title: 'Every day stat',
            permissions: "every_day_stat"

        },
        path: '',
        name: 'every-days-stat',
        component: () => import('@/views/every_days_stat/EveryDaysStatListView.vue')
    },
]